export default function RotatingBadge() {
  const text = "WEBFLOW DEVELOPER • WEBFLOW DEVELOPER • ";
  const chars = text.split("");
  const radius = 62;

  return (
    <div className="relative w-[160px] h-[160px] mx-auto">
      {/* Rotating text ring */}
      <div className="absolute inset-0 rotating-text">
        <svg viewBox="0 0 160 160" className="w-full h-full">
          <defs>
            <path
              id="badge-circle"
              d={`M 80,80 m -${radius},0 a ${radius},${radius} 0 1,1 ${radius * 2},0 a ${radius},${radius} 0 1,1 -${radius * 2},0`}
            />
          </defs>
          <text
            fill="#ffffff"
            style={{
              fontSize: "11px",
              letterSpacing: "3px",
              fontFamily: "'Space Grotesk', sans-serif",
              fontWeight: 600,
            }}
          >
            <textPath href="#badge-circle" startOffset="0">
              {text.repeat(2)}
            </textPath>
          </text>
        </svg>
      </div>

      {/* Center avatar */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[92px] h-[92px] rounded-full overflow-hidden border-2 border-white/10">
        <img
          src="https://readdy.ai/api/search-image?query=Professional%20portrait%20photo%20of%20a%20young%20asian%20male%20designer%20wearing%20a%20black%20hoodie%2C%20soft%20studio%20lighting%2C%20neutral%20dark%20gray%20background%2C%20friendly%20confident%20expression%2C%20natural%20skin%20tone%2C%20high%20detail%20portrait%20photography%2C%20centered%20composition%2C%20editorial%20headshot%20style&width=200&height=200&seq=avatar-john-smith-01&orientation=squarish"
          alt="John Smith portrait"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </div>
  );
}